export default "__VITE_ASSET__CWMBro6r__"